import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import {
  TwitterShareButton,
  TwitterIcon,
  RedditShareButton,
  RedditIcon,
  WhatsappShareButton,
  WhatsappIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
} from 'react-share'
import SubscribeButton from '../../components/SubscribeButton'
import {
  BLOG_PAGE_SIGN_UP_NEWSLETTER_CLICKED,
  BLOG_PAGE_SHARING_BUTTON_CLICKED,
} from '../../helpers/events'
import useAmplitude from '../../hooks/useAmplitude'

export default function SharingComponent({ url, title, sticky }) {
  const emailRef = useRef()
  const { logEvent } = useAmplitude()

  const textColor = sticky ? 'text-gray-400' : 'text-purple-200'

  return (
    <div
      className={`px-2 py-8 rounded-3xl  ${
        sticky
          ? 'sticky top-2 lg:px-2 bg-gray-50'
          : 'lg:px-8 bg-gradient-to-r from-purple-500 to-purple-700'
      }`}>
      <p className={`text-lg font-semibold leading-7 text-center ${textColor}`}>
        Subscribe for more free YouTube stuff 👇
      </p>
      <div className="relative w-full mt-2">
        <input
          ref={emailRef}
          className="flex-grow w-full py-4 pl-6 pr-40 font-bold placeholder-purple-800 border border-gray-200 rounded-full placeholder-font-sm focus:outline-none focus:ring-2 focus:ring-offset-1 ring-purple-800"
          type="email"
          placeholder="E-Mail"
          min={1}
          max={50}
          required
          autoComplete="email"
        />
        <SubscribeButton
          listId="e0fb95d7-9487-4b77-b3d9-c50cf99aa7b1"
          className="absolute px-4 transition-all hover:bg-purple-800 top-2 right-2 bottom-2"
          event={BLOG_PAGE_SIGN_UP_NEWSLETTER_CLICKED}
          onEmail={() => {
            if (!emailRef.current.reportValidity()) {
              return undefined
            }

            return emailRef.current.value
          }}
        />
      </div>
      <p
        className={`mt-8 italic font-normal leading-7 text-center text-md ${textColor}`}>
        Share with a fellow YouTuber 🙏
      </p>
      <div className="flex items-center justify-center px-8 py-3 mt-2 space-x-2 bg-white rounded-full md:space-x-8">
        <TwitterShareButton
          url={url}
          title={title}
          onClick={() =>
            logEvent(BLOG_PAGE_SHARING_BUTTON_CLICKED, { type: 'twitter' })
          }>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <RedditShareButton
          url={url}
          title={title}
          onClick={() =>
            logEvent(BLOG_PAGE_SHARING_BUTTON_CLICKED, { type: 'reddit' })
          }>
          <RedditIcon size={32} round />
        </RedditShareButton>
        <WhatsappShareButton
          url={url}
          title={title}
          onClick={() =>
            logEvent(BLOG_PAGE_SHARING_BUTTON_CLICKED, { type: 'whatsapp' })
          }>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
        <FacebookMessengerShareButton
          url={url}
          title={title}
          onClick={() =>
            logEvent(BLOG_PAGE_SHARING_BUTTON_CLICKED, { type: 'fb-messenger' })
          }>
          <FacebookMessengerIcon size={32} round />
        </FacebookMessengerShareButton>
      </div>
    </div>
  )
}

SharingComponent.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  sticky: PropTypes.bool,
}
